module.exports = __webpack_public_path__ + "static/media/avatar_cow.dd9875f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_cow.png
// module id = 374
// module chunks = 0